<div class="about-dialog">
  <div class="about-header">
    <h2 mat-dialog-title class="about-header__title">About NRG Metrics</h2>
  </div>

  <div mat-dialog-content class="dialog-content">
    <dl class="info-grid">
      <dt>App</dt>
      <dd>{{ appDisplay }}</dd>

      <dt>Server</dt>
      <dd>{{ serverDisplay }}</dd>

      @if (environmentLabel) {
        <dt>Environment</dt>
        <dd>{{ environmentLabel }}</dd>
      }

      <dt>Browser</dt>
      <dd>{{ browser }}</dd>

      <dt>System</dt>
      <dd>{{ system }}</dd>
    </dl>

    <p class="hint">Copy this when reporting a problem.</p>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-stroked-button (click)="copy()">
      <mat-icon>content_copy</mat-icon>
      Copy
    </button>
    <button mat-raised-button color="primary" (click)="onClose()">
      Close
    </button>
  </div>
</div>
